export default "__VITE_ASSET__CS66IB_Q__"